<template>
  <tr class="table-row contact-list-item text-dark-grey">
    <td class="d-none d-sm-table-cell align-middle">
      <img
        v-if="contact.hasProfileImage"
        :src="getImageUrl(contact.id)"
        alt="Profile image"
      />
      <div v_else class="number-circle">
        {{ getInitials(contact.name) }}
      </div>
    </td>
    <td class="table-cell align-middle">
      <span v-if="editContactObj.id !== contact.id">
        {{ contact.name }}
      </span>
      <input
        v-else
        type="text"
        name="editContactName"
        id="editContactName"
        class="form-control"
        v-model.trim="editContactObj.name"
      />
    </td>
    <td class="table-cell align-middle">
      <div
        class="d-inline-block text-truncate"
        style="max-width: 30vw;"
        v-if="editContactObj.id !== contact.id"
      >
        {{ contact.email }}
      </div>
      <input
        v-else
        type="text"
        name="editContactEmail"
        id="editContactEmail"
        class="form-control"
        v-model.trim="editContactObj.email"
      />
    </td>

    <td v-if="0" class="d-none d-sm-table-cell align-middle">
      {{ contact.status }}
    </td>
    <td class="align-middle">
      <div
        class="d-flex justify-content-around align-items-sm-center flex-column flex-sm-row"
      >
        <font-awesome-icon
          @click="editContact(contact)"
          class="my-3 my-sm-0 pointer"
          v-if="editContactObj.id !== contact.id"
          :icon="['fal', 'pencil']"
        />
        <font-awesome-icon
          @click="deleteContact(contact)"
          class="mb-3 mb-sm-0 pointer"
          :icon="['fal', 'trash-alt']"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import shared from '@/shared.js';
export default {
  name: 'ContactListItem',

  props: ['contact'],

  data() {
    return {
      editContactObj: { id: null, name: null, email: null },
    };
  },

  methods: {
    deleteContact(contact) {
      this.$emit('update', { cmd: 'delete', contact:contact});
    },
    editContact(contact) {
      this.$emit('update', { cmd: 'edit', contact:contact});
    },
  },

  created() {
    this.getInitials = shared.getInitials;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.table-cell {
  th {
    font-weight: 400;
    color: red;
    background-color: #191c1f !important;

    padding: 0.25rem 0.75rem;
  }
}

.table {
  tr {
    td {
      padding: 0.25rem 0.5rem;
      font-size: 14px;
    }
  }
}

.table-striped tbody tr:nth-of-type(2n) {
  background-color: rgba(0, 0, 0, 0.1);
}

.table-striped tbody tr:nth-of-type(2n + 1) {
  background-color: rgba(0, 0, 0, 0.01);
}

.number-circle {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;
  text-align: center;
  font: 14px Arial, sans-serif;
  margin: auto;
  text-transform: uppercase;
}
</style>
